export function initMasanyaLottie() {
  const roots = document.querySelectorAll('[data-masanya-lottie]')
  if (!roots.length) {
    return
  }

  let mouseX = window.innerWidth * 0.5
  let mouseY = window.innerHeight * 0.5
  let frameId = null

  const applyPupilTracking = () => {
    roots.forEach((root) => {
      const pupils = root.querySelectorAll('[data-masanya-pupil]')
      if (!pupils.length) {
        return
      }

      const rect = root.getBoundingClientRect()
      const centerX = rect.left + rect.width * 0.52
      const centerY = rect.top + rect.height * 0.45
      const dx = mouseX - centerX
      const dy = mouseY - centerY
      const distance = Math.hypot(dx, dy) || 1
      const maxShift = Math.max(3, Math.min(rect.width, rect.height) * 0.055)
      const shiftX = (dx / distance) * maxShift
      const shiftY = (dy / distance) * maxShift * 0.82

      pupils.forEach((pupil) => {
        pupil.style.transform = `translate3d(${shiftX}px, ${shiftY}px, 0)`
      })
    })
    frameId = null
  }

  const requestUpdate = () => {
    if (frameId !== null) {
      return
    }
    frameId = window.requestAnimationFrame(applyPupilTracking)
  }

  window.addEventListener(
    'mousemove',
    (event) => {
      mouseX = event.clientX
      mouseY = event.clientY
      requestUpdate()
    },
    { passive: true },
  )

  window.addEventListener('resize', requestUpdate, { passive: true })
  requestUpdate()
}
